import { useQuery, UseQueryOptions } from 'react-query';
import { APIError } from '~/src/utils/error';
import { useCurrentOrgFprint } from '../../user';
import { composeQueryOpts } from '../../utils';
import { keys } from '../keys';
import { PlanUpgradeOptionsResponse } from '../types';
import cbsSubscriptionsService from '~/src/services/api/cbsSubscriptionsService';

const queryKey = [...keys.subscription, 'plan-upgrades'] as const;

export const usePlanUpgradeOptions = (
  options: UseQueryOptions<PlanUpgradeOptionsResponse, APIError> = {},
) => {
  const orgFprint = useCurrentOrgFprint();

  return useQuery(
    composeQueryOpts(options, {
      queryKey,
      queryFn: () => cbsSubscriptionsService.getPlanUpgradeOptions(orgFprint),
      enabled: !!orgFprint,
    }),
  );
};
